module.exports = __webpack_public_path__ + "static/media/health-and-wellness.ddbedd69.webp";